{
    "NAME": "Paramètres de journalisationLangue",
    "LoggingSettings_Column_Component": "Composant",
    "LoggingSettings_Column_Enabled": "Activé",
    "LoggingSettings_Column_BackupLogs": "Journaux de sauvegarde",
    "LoggingSettings_Column_Level": "Niveau",
    "LoggingSettings_Column_RollOverFiles": "Fichiers de transfert",
    "LoggingSettings_Column_MaxFileSizeAsMB": "Taille maximale du fichier (Mo)",
    "LoggingSettings_Component_MainServlet": "Servlet principal",
    "LoggingSettings_Component_Database": "Base de données",
    "LoggingSettings_Component_Repository": "Dépôt",
    "LoggingSettings_Component_RptExecMgr": "Gestionnaire d'exécution des rapports",
    "LoggingSettings_Component_MailController": "Contrôleur de messagerie",
    "LoggingSettings_Component_TaskDelegator": "Délégateur de tâches",
    "LoggingSettings_Component_TelephoneModule": "Module téléphonique",
    "LoggingSettings_Component_OmniModule": "Module omnicanal",
    "LoggingSettings_Action_Save": "Sauvegarder",
    "LoggingSettings_Action_Cancel": "Annuler",
    "LoggingSettings_Action_Refresh": "Rafraîchir",
    "LoggingSettings_ReadOnlyWarning": "Vous ne disposez pas des privilèges d'administrateur global pour mettre à jour les paramètres de journalisation.",
    "LoggingSettings_SaveSuccess": "Les paramètres de journalisation ont été enregistrés.",
    "LoggingSettings_SaveError": "Impossible d'enregistrer les paramètres de journalisation.",
    "LoggingSettings_RefreshConfirmTitle": "Supprimer les modifications non enregistrées ?",
    "LoggingSettings_RefreshConfirmBody": "L'actualisation supprimera vos modifications non enregistrées. Continuer ?",
    "LoggingSettings_Empty": "Aucun paramètre de journalisation n'est disponible."
}